
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const Description = ({ t }) => {
    const description = t('coldware_chat:description', {}, { returnObjects: true });
    return (<section className={'description'}>
            <div className="container">
                <div className="description_wrapper">
                    <div className={'description_items'}>
                        <div className={'item_index'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <g clipPath="url(#clip0_313_185)">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.6371 1.19841C14.0628 1.55023 14.1228 2.18055 13.7709 2.60628L5.7309 12.3355L5.72848 12.3384C5.5456 12.558 5.31608 12.7341 5.05661 12.8538C4.79713 12.9736 4.51423 13.034 4.22848 13.0307C3.93805 13.0271 3.65131 12.9577 3.39152 12.8278C3.1326 12.6984 2.90626 12.5121 2.72937 12.283L0.210694 9.04474C-0.128376 8.6088 -0.049842 7.98052 0.386105 7.64145C0.822053 7.30238 1.45033 7.38092 1.7894 7.81686L4.25297 10.9843L12.2292 1.33225C12.581 0.906522 13.2114 0.846601 13.6371 1.19841Z" fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_313_185">
                                        <rect width="14" height="14" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <h2 className={'item_title'}>
                            <span>{description.title_1}</span>
                            <span>{description.title_2}</span>
                            <span>{description.title_3}</span>
                            <span>{description.title_4}</span>
                        </h2>
                        <p className={'item_description'}>{description.text}</p>
                    </div>
                    <div className={'description_media'}>
                        <picture>
                            <source media="(max-width: 768px)" srcSet={`/img/pages/ecosystem/cold_chat/description/chat_1_small.webp`} type="image/webp"/>
                            <source media="(min-width: 769px)" srcSet={`/img/pages/ecosystem/cold_chat/description/chat_1.webp`} type="image/webp"/>
                            <source media="(max-width: 768px)" srcSet={`/img/pages/ecosystem/cold_chat/description/chat_1_small.png`}/>
                            <source media="(min-width: 769px)" srcSet={`/img/pages/ecosystem/cold_chat/description/chat_1.png`}/>
                            <img src={`/img/pages/ecosystem/cold_chat/description/chat_1.png`} alt={`ColdWare Chat`} width={626} height={884} className='description_media_img first'/>
                        </picture>
                        <picture>
                            <source media="(max-width: 768px)" srcSet={`/img/pages/ecosystem/cold_chat/description/chat_2_small.webp`} type="image/webp"/>
                            <source media="(min-width: 769px)" srcSet={`/img/pages/ecosystem/cold_chat/description/chat_2.webp`} type="image/webp"/>
                            <source media="(max-width: 768px)" srcSet={`/img/pages/ecosystem/cold_chat/description/chat_2_small.png`}/>
                            <source media="(min-width: 769px)" srcSet={`/img/pages/ecosystem/cold_chat/description/chat_2.png`}/>
                            <img src={`/img/pages/ecosystem/cold_chat/description/chat_2.png`} alt={`ColdWare Chat`} width={971} height={1064} className='description_media_img second'/>
                        </picture>
                    </div>
                </div>
            </div>
        </section>);
};
export default Description;

    async function __Next_Translate__getStaticProps__196111db541__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//ecosystem/chat/Description/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196111db541__ as getStaticProps }
  